import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { FONTS } from '@styles/fonts'
import styled from 'styled-components'

export const SubTitle = styled.span`
  font-size: 14px;
  color: ${COLORS.grey[60]};
  font-family: ${FONTS.regular};
  display: flex;
  align-items: center;
  text-transform: none;
  white-space: nowrap;
  letter-spacing: 0.2px;

  svg {
    margin-left: 12px;
  }
`

export const ToggleButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  padding-top: 45px;

  ${DEVICES.mobile} {
    padding-top: 0;
  }

  button {
    margin-left: 0;
  }
`
